import React from 'react';
import cx from 'classnames';
import DragScroll from 'react-indiana-drag-scroll';
import Img from '../../../../../../../components/Img/Img';
import { PRODUCT_WIDGET_LAYOUT_TYPE_V2, ProductWidgetDetailV2 } from '../../../../../../../types/widget';
import PreviewSimpleProductCard from '../../../../../../../components/preview/PreviewSimpleProductCard';
import PreviewProductCard from '../../../../../../../components/preview/PreviewProductCard';
import { ProductWidgetSwipeLayoutStyle } from './style';

export type ProductWidgetSwipeLayoutDetail = ProductWidgetDetailV2 & {
  layoutType: typeof PRODUCT_WIDGET_LAYOUT_TYPE_V2.SWIPE_BIG_1XN | typeof PRODUCT_WIDGET_LAYOUT_TYPE_V2.SWIPE_SMALL_1XN;
};

interface ProductWidgetSwipeLayoutProps {
  detail: ProductWidgetSwipeLayoutDetail;
}
const ProductWidgetSwipeLayout = (props: ProductWidgetSwipeLayoutProps) => {
  const { detail } = props;
  const { topImage, widgetItemProducts, layoutType } = detail;
  const isSmallSwipe = layoutType === PRODUCT_WIDGET_LAYOUT_TYPE_V2.SWIPE_SMALL_1XN;

  return (
    <ProductWidgetSwipeLayoutStyle>
      {
        /**
         *  위젯 탑 이미지
         */
        topImage && topImage[0]?.url ? (
          <Img className="widget-top-image" clickAble={false} src={topImage[0].url} />
        ) : null
      }
      <div className="widget-product-section-swipe">
        <DragScroll className={cx('widget-product-section', isSmallSwipe ? 'small' : 'big')}>
          {widgetItemProducts?.map((productItem) =>
            isSmallSwipe ? (
              <PreviewSimpleProductCard key={productItem.id} className="widget-product-item" product={productItem} />
            ) : (
              <PreviewProductCard key={productItem.id} className="widget-product-item" product={productItem} />
            ),
          )}
        </DragScroll>
      </div>
    </ProductWidgetSwipeLayoutStyle>
  );
};

export default ProductWidgetSwipeLayout;
